import { Translations } from "../types";
import { en } from "./en";
import { fr } from "./fr";
import { de } from "./de";
import { pl } from "./pl";

export const translations: Translations = {
  en,
  fr,
  de,
  pl,
};

